var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonettaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 158,
    height: 32,
    viewBox: "0 0 158 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158,
    height: 32,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.222,26.923V38.009h-5.829V34.736a8.7,8.7,0,0,1-6.936,3.247c-5.937,0-10.058-4.54-10.058-11.061s4.7-11.113,11.372-11.113,11.45,4.644,11.45,11.113Zm-16.492,0c0,3.169,2.127,5.465,5.068,5.465s5.068-2.3,5.068-5.465-2.127-5.491-5.068-5.491S315.73,23.7,315.73,26.923Z",
    transform: "translate(-175.616 -8.974)",
    fill: "#00ce7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.127,27.167c0-6.438-4.436-10.927-10.793-10.927-6.75,0-11.424,4.462-11.424,10.849s4.255,10.771,10.533,11.087c.393.026.787.052,1.18.052a10.781,10.781,0,0,0,7.433-2.694c.078-.052.13-.134.212-.186a7282.408,7282.408,0,0,0,.424-.476,9.579,9.579,0,0,0,2.076-3.775H208.6c-.553,1.4-2.339,2.348-4.307,2.348a4.914,4.914,0,0,1-4.752-3.775H214.9a12.08,12.08,0,0,0,.238-2.508Zm-15.891-1.133c.368-2.984,2.1-5.016,4.752-5.016a4.842,4.842,0,0,1,4.834,5.016Z",
    transform: "translate(-109.496 -9.218)",
    fill: "#00ce7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.214,15.2a10.254,10.254,0,0,0-6.962,2.72A10.285,10.285,0,0,0,0,25.547V37.689H6.672V25.547a3.6,3.6,0,1,1,7.2,0V37.689h6.672V25.547a3.6,3.6,0,1,1,7.2,0V37.689h6.672V25.547A10.2,10.2,0,0,0,24.214,15.2Z",
    transform: "translate(0 -8.628)",
    fill: "#00ce7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.364,37.689V25.547a3.6,3.6,0,1,1,7.2,0V37.689h6.672V25.547a10.3,10.3,0,1,0-20.591,0V37.689h6.724Z",
    transform: "translate(-80.395 -8.628)",
    fill: "#00ce7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.41,27.613a3.61,3.61,0,0,1-3.6-3.615V16.686h4.41v-4.8h-4.41v-.026h-.13V7.45h-6.356v4.406h-.186v.026H276.49v4.8h2.651V24a10.337,10.337,0,0,0,10.3,10.347c.342,0,.709-.026,1.051-.052v-6.81a5.1,5.1,0,0,1-1.077.134Z",
    transform: "translate(-156.937 -4.229)",
    fill: "#00ce7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.932,27.613h-.052a3.61,3.61,0,0,1-3.6-3.615V16.686h4.41v-4.8h-4.41v-.026h-.13V7.45H247.8v4.406h-.186v.026H244.96v4.8h2.651V24a10.337,10.337,0,0,0,10.3,10.347h.052V27.613h-.026Z",
    transform: "translate(-139.04 -4.229)",
    fill: "#00ce7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.76,17a39.952,39.952,0,0,1,9.348,1.029,11.321,11.321,0,0,0,2.153-6.836c0-6.624-4.7-11.19-11.476-11.19S84.31,4.566,84.31,11.19a11.251,11.251,0,0,0,2.127,6.836A41.005,41.005,0,0,1,95.76,17Zm0-11.774c2.966,0,5.094,2.27,5.094,5.517s-2.127,5.491-5.094,5.491-5.094-2.27-5.094-5.491,2.075-5.517,5.094-5.517Z",
    transform: "translate(-47.855)",
    fill: "#00ce7c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonettaLogo);
export default __webpack_public_path__ + "static/media/monetta-logo.1d3488be143865610697cd14601478d8.svg";
export { ForwardRef as ReactComponent };